import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import type { TCorePowerschoolFeeCartLine } from '@/types/cart'

export const corePowerschoolFees = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/core_powerschool_fees'
  )
  return Util.Obj.keysToCamel(response.data.items) as TCorePowerschoolFeeCartLine[]
}
